var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center",class:_vm.containerClasses},[_c('v-expand-x-transition',[_c('v-progress-circular',{attrs:{"width":_vm.width,"size":_vm.size,"indeterminate":"","color":_vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }